import React, { Component } from 'react';
import Purchase from '../Purchase';
import PayPurchase from '../PayPurchase';

class InsurancePurchase extends Component {
  componentDidMount() {
    this.fetchData();
  }
  componentDidUpdate(oldProps) {
    if (this.props.purchaseId !== oldProps.purchasId) {
      this.fetchData();
    }
  }
  fetchData = () => {
    const { purchaseId, findPurchase } = this.props;
    findPurchase(purchaseId);
  }

  render() {
    const { purchaseId, contractId, activateContract } = this.props;
    if (!purchaseId || !contractId) { return null; }

    return (
      <React.Fragment>
        <Purchase id={purchaseId} />
        <PayPurchase id={purchaseId} message={'Your payment was successful, and your device protection was activated.\n You will receive a welcome email from Likewize, the claim administrator.'} onComplete={() => activateContract(contractId)} />
      </React.Fragment>
    )
  }
}

export default InsurancePurchase;
